import { createSlice } from "@reduxjs/toolkit";

export const areaDataSlice = createSlice({
    name: 'areadata',
    initialState: {
        // loading: false,
        region: [],
        province: [],
        amphur: [],
        tambon: [],
        regionmap: {},
        provincemap: {},
        amphurmap: {},
        tambonmap: {}
    },
    reducers: {
        // setLoadingAreaData: (state, action) => {
        //     state.loading = action.payload;
        // },
        setRegionData: (state, action) => {
            state.region = action.payload;
        },
        setProvinceData: (state, action) => {
            state.province = action.payload;
        },
        setAmphurData: (state, action) => {
            state.amphur = action.payload;
        },
        setTambonData: (state, action) => {
            state.tambon = action.payload;
        },
        setRegionDataMap: (state, action) => {
            state.regionmap = action.payload;
        },
        setProvinceDataMap: (state, action) => {
            state.provincemap = action.payload;
        },
        setAmphurDataMap: (state, action) => {
            state.amphurmap = action.payload;
        },
        setTambonDataMap: (state, action) => {
            state.tambonmap = action.payload;
        }

    }
})

export const {
    // setLoadingAreaData,
    setRegionData,
    setProvinceData,
    setAmphurData,
    setTambonData,
    setRegionDataMap,
    setProvinceDataMap,
    setAmphurDataMap,
    setTambonDataMap
} = areaDataSlice.actions;

// export const getLoadingAreaData = (state) => state.areadata.loading;
export const getRegionData = (state) => state.areadata.region;
export const getProvinceData = (state) => state.areadata.province;
export const getAmphurData = (state) => state.areadata.amphur;
export const getTambonData = (state) => state.areadata.tambon;
export const getRegionDataMap = (state) => state.areadata.regionmap;
export const getProvinceDataMap = (state) => state.areadata.provincemap;
export const getAmphurDataMap = (state) => state.areadata.amphurmap;
export const getTambonDataMap = (state) => state.areadata.tambonmap;

export default areaDataSlice.reducer;